import { handleResponse, axiosInstance, API } from './helper';
import { getGroupbyId } from './keycloak';

/**
 * Gets all practice departments for a specific organisation
 * @param organisationId - The organisation ID to get departments for
 * @returns Promise with the departments data
 */
const getPracticeDepartments = (organisationId: string) => {
  return handleResponse(
    axiosInstance.get(`${API.getPracticeDepartments}?organisationId=${organisationId}`)
  );
};

/**
 * Gets department details from Keycloak by department ID
 * @param departmentId - The department ID to get details for
 * @returns Promise with the department details from Keycloak
 */
const getDepartmentDetails = async (departmentId: string) => {
  const token = localStorage.getItem('user_access_token');
  if (!token || !departmentId) {
    return null;
  }
  return await getGroupbyId(departmentId, token);
};

/**
 * Inserts a new department in the database
 * @param departmentData - The department data to insert
 * @returns Promise with the inserted department data
 */
const insertDepartment = (departmentData: {
  id: string;
  description: string;
  organisationId: string;
  type: string;
}) => {
  return handleResponse(
    axiosInstance.post(`${API.insertPractiseAdminDepartments}`, departmentData)
  );
};

/**
 * Updates a department's description and type in Hasura
 * @param id - Department ID
 * @param description - New description
 * @param type - New type
 * @returns Promise with the updated department data
 */
export const updateDepartmentHasura = (id: string, description: string, type: string) => {
  return handleResponse(
    axiosInstance.put('v1/update-practise-department', {
      id,
      description,
      type
    })
  );
};

export { getPracticeDepartments, getDepartmentDetails, insertDepartment };
